import React from "react";
import Paper from "@mui/material/Paper";
import styles from "./loginWrapper.style";
import Button from "@mui/material/Button";
import { Box, useTheme } from "@mui/material";
import Typography from "@mui/material/Typography";
import { autoPlay } from "react-swipeable-views-utils";
import MobileStepper from "@mui/material/MobileStepper";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import SwipeableViews, { SwipeableViewsProps } from "react-swipeable-views";
// import type { SwipeableViewsProps } from "react-swipeable-views-utils";
import { IMAGES } from "../../../common/constants";

const AutoPlaySwipeableViews = autoPlay(
  SwipeableViews,
) as React.FC<SwipeableViewsProps>;

const images = [
  {
    id: 1,
    imgPath: IMAGES.SliderImage1,
    label: "Transparency built into every product",
  },
  {
    id: 2,
    imgPath: IMAGES.SliderImage2,
    label: "Engage with your consumers",
  },
  {
    id: 3,
    imgPath: IMAGES.SliderImage3,
    label: "Build trust through verified feedback",
  },
];

interface Props {
  childComp: React.ReactNode;
}

const LoginWrapper = ({ childComp }: Props) => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step: number) => {
    setActiveStep(step);
  };
  return (
    <div className="login-wrapper">
      <div className="wraper-item">
        <div className="slider-wraper">
          <div className="logo-box">
            <img src={IMAGES.Logo} alt=".." />
          </div>
          <Box sx={{ maxWidth: 560 }}>
            <AutoPlaySwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={activeStep}
              onChangeIndex={handleStepChange}
              enableMouseEvents
            >
              {images.map((step, index) => (
                <div className="slider" key={step.id}>
                  {Math.abs(activeStep - index) <= 2 ? (
                    <Box
                      component="img"
                      sx={{
                        height: "auto",
                        display: "block",
                        maxWidth: "100%",
                        overflow: "hidden",
                        width: "100%",
                      }}
                      src={step.imgPath}
                      alt={step.label}
                    />
                  ) : null}
                </div>
              ))}
            </AutoPlaySwipeableViews>
            <Paper
              square
              elevation={0}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: 100,
                bgcolor: "transparent",
              }}
            >
              <Typography>{images[activeStep].label}</Typography>
            </Paper>
            <MobileStepper
              sx={{ bgcolor: "transparent", justifyContent: "center" }}
              steps={maxSteps}
              position="static"
              activeStep={activeStep}
              nextButton={
                <Button
                  sx={{ display: "none" }}
                  size="small"
                  onClick={handleNext}
                  disabled={activeStep === maxSteps - 1}
                >
                  Next
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowLeft />
                  ) : (
                    <KeyboardArrowRight />
                  )}
                </Button>
              }
              backButton={
                <Button
                  sx={{ display: "none" }}
                  size="small"
                  onClick={handleBack}
                  disabled={activeStep === 0}
                >
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowRight />
                  ) : (
                    <KeyboardArrowLeft />
                  )}
                  Back
                </Button>
              }
            />
          </Box>
        </div>
      </div>
      <div className="wraper-item">
        <div className="form-seaction">
          <Box sx={styles.mainContainer}>
            <Box sx={styles.childContainer}>{childComp}</Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default LoginWrapper;
